export default __webpack_public_path__ + "static/media/survey-intro.4e0b7fe4.png";